"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ShowHide = void 0;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
/**
Conditionally show/hide content
*/


var ShowHide = exports.ShowHide = function (a) {
  var b = a.children,
      c = a.show;
  return c ? b : null;
};

ShowHide.propTypes = {
  show: _propTypes2.default.bool,
  children: _propTypes2.default.any //eslint-disable-line

}, ShowHide.defaultProps = {
  show: !1,
  children: null
}, exports.default = _react2.default.memo(ShowHide);